/** Explicit height overrides a bundled image's intrinsic native height. */
export function tutorialImageHeight(cardWidth: number, compact: boolean): number {
  return Math.min(Math.max(0, cardWidth - 4) / (compact ? 1.85 : 1.7), compact ? 205 : 360)
}
